import { NotificationContext } from './../../../context/NotificationContext'
import { useContext } from 'react'

const typeClasses = {
  success:
    'bg-primary/95 text-primary-foreground border border-accent/50 shadow-primary/30',
  error:
    'bg-rose-600/95 text-rose-50 border border-rose-500/70 shadow-rose-500/30',
  info:
    'bg-primary/90 text-primary-foreground border border-accent/30 shadow-primary/20',
}

const NotificationToast = () => {
  const { notifications = [] } = useContext(NotificationContext)

  if (!notifications.length) return null

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-3 max-w-sm w-full">
      {notifications.map((n) => {
        const base =
          n.type === 'success'
            ? typeClasses.success
            : n.type === 'error'
            ? typeClasses.error
            : typeClasses.info

        return (
          <div
            key={n.id}
            className={`${base} px-4 py-3 rounded-xl text-sm font-medium shadow-lg backdrop-blur-md animate-slide-up`}
          >
            {n.message}
          </div>
        )
      })}
    </div>
  )
}

export default NotificationToast